import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Firebase } from "@ionic-native/firebase";
import { Platform } from "ionic-angular";
import { AngularFirestore } from "@angular/fire/firestore";
import { Device } from "@ionic-native/device";

@Injectable()
export class FirebaseProvider {
  constructor(
    public http: HttpClient,
    private firebase: Firebase,
    private platform: Platform,
    private afs: AngularFirestore,
    private device: Device
  ) {}

  async getToken(userName) {
    let token;

    if (this.platform.is("android")) {
      token = await this.firebase.getToken();
    }

    if (this.platform.is("ios")) {
      token = await this.firebase.getToken();
      await this.firebase.grantPermission();
    }

    this.saveToken(token, userName);
  }

  private saveToken(token, userName) {
    if (!token) return;

    let uuid = this.device.uuid;
    let version = this.device.version;
    let platform = this.device.platform;

    const devicesRef = this.afs.collection("devices");

    const data = {
      token,
      userName: userName,
      uuid: uuid,
      version: version,
      platform: platform
    };
    return devicesRef.doc(userName).set(data);
  }

  onNotificationOpen() {
    console.log('notification open')
    return this.firebase.onNotificationOpen();
  }

  onTokenRefresh() {
    this.firebase
      .onTokenRefresh()
      .subscribe((token: string) => console.log(`Got a new token ${token}`));
  }
}



// WEBPACK FOOTER //
// ./src/providers/firebase/firebase.ts